interface Props {
  label: string
  value: string
  hint?: string
  accent?: 'emerald' | 'red' | 'amber'
  size?: 'md' | 'lg'
}

export function Stat({ label, value, hint, accent, size = 'md' }: Props) {
  const valueClass =
    accent === 'emerald'
      ? 'text-emerald-400'
      : accent === 'red'
        ? 'text-red-400'
        : accent === 'amber'
          ? 'text-amber-400'
          : 'text-zinc-100'
  const valueSize = size === 'lg' ? 'text-2xl' : 'text-lg'
  return (
    <div className="min-w-[120px]">
      <div className="text-xs text-zinc-400 uppercase tracking-wider mb-0.5">{label}</div>
      <div className={`font-mono ${valueSize} ${valueClass}`}>{value}</div>
      {hint && <div className="text-[11px] text-zinc-500 mt-0.5">{hint}</div>}
    </div>
  )
}
